/** Budget history chart axis thresholds. */
export const budgetHistoryChartConf = {
  /** Use broken budget Y axis when the graph max budget magnitude exceeds this amount. */
  brokenAxisWhenMaxBudgetAbove: 50_000,
} as const
